class ResourceDirective
  @$inject: ["$rootScope", "$injector", "$timeout", "$filter"]
  constructor: ($rootScope, $injector, $timeout, $filter)->
    class Resource
      scope: true
      bindToController: true
      controllerAs: "$resource"
      controller: ($scope, $element, $attrs)->
        @limit = $attrs.limit ? 5
        $scope.$watch $attrs.collectionResources, (val)=>
          if val
            if val[0]?.device?
              val.forEach (device)->
                  device.$selected = false;
            @list = @dataset = val
            $scope.$pagination =
              total: val.length
              limit: @limit
              page: 1
            @move(1)
            $scope.$watch $attrs.search, (val)=>
              $scope.$parent.filterCurrentStatus = {abbrev: 'All', name: 'ALL'}
              $scope.criteria = val
              @search(val)
            , true
            $scope.$watch $attrs.selectedstatus, (val)=>
              @sortStatus(val)
            , true
            $scope.$watch $attrs.selectdevice, (val)=>
              @select(val)
            , true
            if val[0]?.device?
              $scope.$watch $attrs.selectedList, (val)=>
                @checkListDevices(val)
              , true
        , true

        @move = (page) =>
          # if @list[0]?.device? or @list is undefined or @list.length is 0
          #   $scope.$parent.listOfCurrentDevice = @list
          start = (page - 1) * @limit
          $scope.$dataset = $filter("limitTo")(@list, @limit, start)

        @sortStatus = (status) => 
          @search($scope.criteria)
          newList = [];
          if status
            if status.abbrev is 'All'
               newList = @list
            for element, index in @list
              if element.status is status.abbrev
                newList.push(element)
            @list = newList
            $scope.$pagination =
                total: @list.length
                limit: @limit
                page: 1
            @move(1)
            $scope.$parent.allSelected = @allSelectedChecker @list

        @search = (term)=>
          if !term or term.length is 0
            term = ''
          @list = $filter('filter')(@dataset, term);
          $scope.$pagination =
              total: @list.length
              limit: @limit
              page: 1
          @move(1)
          if @list?[0]?.device
            $scope.$parent.allSelected = @allSelectedChecker @list
          

        @select = (selectData)->
          if selectData
            {selectedSource, selected} = selectData
            $scope.$dataset.forEach (source)->
              if source.device._id is selectedSource.device._id
                source.$selected = selected
            $scope.$parent.allSelected = @allSelectedChecker @list
            # $scope.$parent.selectedList = {pressingAllCheckButton: false, allSelected: $scope.$parent.allSelected}

        @checkListDevices = (option)->
          if option?.pressingAllCheckButton
            for device in @list
              device.$selected = option.allSelected

        @allSelectedChecker = (devices)->
          if devices?.length is 0 or !devices
            return false
          for device in devices 
            if device.$selected is false
              return false
          return true      

        return @
    return new Resource()


module.exports = ResourceDirective


// WEBPACK FOOTER //
// ./src/common/resource/collection/index.coffee